import React, { useEffect, useState } from 'react';

type Req = (path: string, body?: any, signal?: AbortSignal) => Promise<any>;

// Owner kill switch for bets mirrored from Fady's paper workspace into the live Auto grid.
const FadyMirrorToggle: React.FC<{ request: Req }> = ({ request }) => {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const ac = new AbortController();
    request('/api/rolling/simple-bsp/fady-mirror', undefined, ac.signal)
      .then((d: any) => setEnabled(!!d.enabled)).catch((e: any) => { if (!ac.signal.aborted) setError(e.message); });
    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function flip() {
    if (enabled === null) return;
    const next = !enabled;
    if (!window.confirm(next ? 'Mimic Fady? His paper bets (manual and Fady lane, including duplicates of yours) will be placed LIVE from your account at his stakes.' : 'Stop mimicking Fady? Every Fady bet not yet submitted will be withdrawn.')) return;
    setBusy(true); setError('');
    try { const d = await request('/api/rolling/simple-bsp/fady-mirror', { enabled: next }); setEnabled(!!d.enabled); }
    catch (e: any) { setError(e.message); } finally { setBusy(false); }
  }
  return (
    <div className="fady-mirror-toggle" role="group" aria-label="Mimic Fady">
      <strong>Mimic Fady</strong>
      <span className={'fady-mirror-state ' + (enabled ? 'on' : 'off')}>{enabled === null ? '…' : enabled ? 'ON — live' : 'OFF'}</span>
      <button type="button" disabled={busy || enabled === null} onClick={flip}>{enabled ? 'Stop mimicking Fady' : 'Mimic Fady'}</button>
      <small>Adds every bet Fady makes (manual and Fady lane, duplicates included) to this live grid at his $ stake, max $1,000 each. His stake edits, horse changes and deletions follow until 30s before the jump. Off withdraws any not yet submitted. Lays and multiples are not copied.</small>
      {error && <span role="alert">{error}</span>}
    </div>
  );
};
export default FadyMirrorToggle;
